<template>
  <div class="font-sans text-[#1D1D1F] bg-[#FBFBFD] overflow-hidden antialiased">
    <section class="relative h-[50vh] lg:h-[60vh] overflow-hidden" data-aos="fade">
      <img
        :src="aboutBanner"
        alt="About NovaLingua"
        class="absolute inset-0 w-full h-full object-cover scale-105 animate-slow-zoom"
      />
      <div class="absolute inset-0 bg-black/40 flex flex-col justify-center items-center text-center px-6 backdrop-blur-[2px]">
        <h1 class="text-4xl lg:text-6xl font-bold text-white tracking-tighter" data-aos="fade-up" data-aos-duration="1000">
          À propos de NovaLingua
        </h1>
        <p class="mt-4 text-white/90 text-lg lg:text-xl max-w-2xl font-light tracking-tight" data-aos="fade-up" data-aos-delay="200">
          Apprenez les langues autrement, progressez vers vos rêves.
        </p>
      </div>
    </section>

    <section class="py-24 bg-white">
      <div class="container mx-auto px-6 lg:px-24 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div class="relative" data-aos="fade-right">
          <img :src="aboutImage" alt="NovaLingua Center" class="apple-img" />
          <div class="absolute -bottom-6 -right-6 hidden lg:block bg-blue-600 text-white p-8 rounded-3xl shadow-2xl">
            <span class="text-3xl font-bold italic">100%</span>
            <p class="text-xs uppercase tracking-widest opacity-80">Engagement</p>
          </div>
        </div>
        
        <div class="space-y-8" data-aos="fade-left">
          <div class="inline-block px-4 py-1 rounded-full bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-widest">
            Notre Mission
          </div>
          <h2 class="text-4xl lg:text-5xl font-bold tracking-tighter text-gray-900 leading-tight">
            Une expertise <br/><span class="text-blue-600">sans frontières.</span>
          </h2>
          <div class="space-y-6 text-gray-500 text-lg font-light leading-relaxed">
            <p>
              Bienvenue au <span class="font-semibold text-gray-900">Centre Linguistique NovaLingua</span>, un espace d’apprentissage moderne situé à <span class="text-gray-900">Bafoussam</span> et <span class="text-gray-900">Dschang</span>.
            </p>
            <p>
              Nos formations couvrent <span class="text-blue-600 font-medium">l’allemand, l’anglais, le français et l’italien</span>. Nous mettons l'accent sur l'immersion et la pratique réelle pour garantir votre départ à l'étranger.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-[#F5F5F7] py-24">
      <div class="container mx-auto px-6 lg:px-20">
        <div class="text-center mb-16" data-aos="fade-up">
          <h3 class="text-3xl lg:text-4xl font-bold tracking-tighter">Nos Localisations</h3>
          <p class="text-gray-500 mt-2 font-light">Retrouvez-nous dans nos campus modernes.</p>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div class="ios-card group" data-aos="fade-up" data-aos-delay="100">
  <div class="flex items-start gap-6">
    <div class="w-12 h-12 rounded-2xl bg-blue-600 flex items-center justify-center text-white shrink-0 shadow-lg group-hover:scale-110 transition-transform">
      📍
    </div>
    
    <div>
      <h4 class="text-xl font-bold mb-4">Campus Bafoussam</h4>
      <ul class="space-y-3 text-gray-500 font-light text-[15px]">
        <li>
          <strong class="text-gray-900 font-medium italic">Quartier Ndiendam</strong>, 
          près du marché de l’entrée.
        </li>
        
        <li class="flex items-center gap-2">
          📱 
          <a href="https://wa.me/237656531225" target="_blank" class="hover:text-blue-600 hover:underline transition-colors font-medium">
            +237 656 53 12 25
          </a>
        </li>

        <li class="flex items-center gap-2">
          ✉️ 
          <a href="mailto:novalinguabafoussam@gmail.com" class="hover:text-blue-600 hover:underline transition-colors">
            novalinguabafoussam@gmail.com
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

          <div class="ios-card group" data-aos="fade-up" data-aos-delay="200">
  <div class="flex items-start gap-6">
    <div class="w-12 h-12 rounded-2xl bg-indigo-600 flex items-center justify-center text-white shrink-0 shadow-lg group-hover:scale-110 transition-transform">
      📍
    </div>
    <div>
      <h4 class="text-xl font-bold mb-4">Campus Dschang</h4>
      <ul class="space-y-3 text-gray-500 font-light text-[15px]">
        <li>
          <strong class="text-gray-900 font-medium italic">En Face de l'entree de la chefferie Foto</strong>, 
          dans l'immeuble abritant la boulangerie la paix et  la pharmacie de l'unite au 2eme etage.
        </li>
        
        <li class="flex items-center gap-2">
          📱 
          <a href="https://wa.me/237695632089" target="_blank" class="hover:text-indigo-600 hover:underline transition-colors font-medium">
            +237 695 63 20 89
          </a>
        </li>

        <li class="flex items-center gap-2">
          ✉️ 
          <a href="mailto:novalinguabafoussam@gmail.com" class="hover:text-indigo-600 hover:underline transition-colors">
            novalinguabafoussam@gmail.com
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
        </div>

        <div class="mt-16 ios-glass p-8 rounded-[2.5rem] border border-white text-center shadow-xl" data-aos="zoom-in">
           <p class="text-gray-500 uppercase tracking-widest text-xs font-bold mb-2">Direction Générale (Allemagne)</p>
           <p class="text-2xl font-bold text-gray-900 tracking-tight">
             <a href="https://wa.me/491754126763" target="_blank" class="hover:text-indigo-600 hover:underline transition-colors font-medium">
                +49 175 412 67 63
          </a>
            </p>
           <div class="mt-8">
             <button class="bg-gray-900 text-white px-8 py-4 rounded-full font-bold hover:bg-gray-800 transition-all active:scale-95">
               Inscriptions Ouvertes : A1 au C1
             </button>
           </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

onMounted(() => {
  AOS.init({
    duration: 800,
    easing: "ease-out-cubic",
    once: true,
  });
});

const aboutBanner = require("@/assets/images/novalingua.jpg");
const aboutImage = require("@/assets/images/novalingua.jpg");
</script>

<style scoped>
/* Typographie Apple-like */
.font-sans {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", Arial, sans-serif;
}

/* Bordures progressives (Squircle style) */
.apple-img {
  @apply rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.1)] w-full h-auto object-cover border-8 border-white;
}

/* Cartes style iOS */
.ios-card {
  @apply bg-white p-10 rounded-[2.5rem] shadow-[0_4px_20px_rgba(0,0,0,0.02)] border border-gray-100 transition-all duration-500 hover:shadow-[0_30px_60px_rgba(0,0,0,0.1)] hover:-translate-y-2;
}

/* Effet de verre (Glassmorphism) */
.ios-glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

/* Animations personnalisées */
@keyframes slow-zoom {
  0% { transform: scale(1); }
  100% { transform: scale(1.1); }
}
.animate-slow-zoom {
  animation: slow-zoom 20s linear infinite alternate;
}

/* Feedback tactile pour les boutons */
button:active {
  transform: scale(0.95);
}

/* Tracking serré pour les titres Apple */
.tracking-tighter {
  letter-spacing: -0.02em;
}
</style>